
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import { IScheduleItem, JobScheduleItem } from '@/views/schedule/ScheduleModels';
  import ScheduleCard from '@/views/schedule/ScheduleCard.vue';
  import { JobType, EnumModel, JobTypeEnums, JobItemType } from '@/common/enumerations';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';

  @Component({
    components: {
      ScheduleCard
    }
  })
  export default class ScheduleCardExample extends Vue {
    private blockUndergroundAssigned: JobScheduleItem = new JobScheduleItem();
    private blockOverheadUnassigned: JobScheduleItem = new JobScheduleItem();
    private blockDraftingAssigned: JobScheduleItem = new JobScheduleItem();


    private mounted() {
      this.blockUndergroundAssigned.id = 'testid';
      this.blockUndergroundAssigned.numberOfLots = 10;
      this.blockUndergroundAssigned.serviceType = 'Cable Haul';
      this.blockUndergroundAssigned.jobItemType = JobItemType.Underground;
      this.blockUndergroundAssigned.network = 'AusNet';
      this.blockUndergroundAssigned.jobName = 'ASSIGNED TEST JOB NAME';
      this.blockUndergroundAssigned.jobItemName = 'The assigned job item name';
      this.blockUndergroundAssigned.notes = 'Some notes about the job';
      this.blockUndergroundAssigned.assignedToEmployee = 'Tony Hawk';
      this.blockUndergroundAssigned.status = 'Assigned';
      this.blockUndergroundAssigned.scheduledTimeRange = 'First Job';
      this.blockUndergroundAssigned.networkHexColor = 'c4ed74';

      this.blockOverheadUnassigned.id = 'testid';
      this.blockOverheadUnassigned.numberOfLots = 10;
      this.blockOverheadUnassigned.serviceType = 'Pre-Commission';
      this.blockOverheadUnassigned.jobItemType = JobItemType.Overhead;
      this.blockOverheadUnassigned.network = 'Jemena';
      this.blockOverheadUnassigned.jobName = 'UNASSIGNED TEST JOB NAME';
      this.blockOverheadUnassigned.jobItemName = 'The unassigned job item name';
      this.blockOverheadUnassigned.notes = 'Some notes about the job';
      this.blockOverheadUnassigned.assignedToEmployee = '';
      this.blockOverheadUnassigned.status = 'Assigned';
      this.blockOverheadUnassigned.scheduledTimeRange = 'First Job';
      this.blockOverheadUnassigned.networkHexColor = 'cd291f';


      this.blockDraftingAssigned.id = 'testid';
      this.blockDraftingAssigned.scheduledTimeRange = 'After 2pm';
      this.blockDraftingAssigned.serviceType = 'Drafting';
      this.blockDraftingAssigned.jobItemType = JobItemType.Drafting;
      this.blockDraftingAssigned.network = 'Jemena';
      this.blockDraftingAssigned.jobName = 'UNASSIGNED TEST JOB NAME';
      this.blockDraftingAssigned.jobItemName = 'Drafting';
      this.blockDraftingAssigned.notes = 'Some notes about the job';
      this.blockDraftingAssigned.assignedToEmployee = 'Dave Grohl';
      this.blockDraftingAssigned.status = 'Assigned';
      this.blockDraftingAssigned.networkHexColor = 'fcaf6f';
    }
  }
